export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2C5F7C] text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-4 gap-12 mb-24">
          <div>
            <h4 className="text-base font-semibold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              <a href="#practice-info" className="hover:text-[#A8DADC] transition-colors">Practice Info</a>
            </h4>
            <div className="w-12 h-px bg-white/30 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Client Stories
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Our Space
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Location
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              <a href="#services" className="hover:text-[#A8DADC] transition-colors">Services</a>
            </h4>
            <div className="w-12 h-px bg-white/30 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Individual Therapy
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Couples Therapy
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Group Sessions
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Specialized Care
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              <a href="#resources" className="hover:text-[#A8DADC] transition-colors">Resources</a>
            </h4>
            <div className="w-12 h-px bg-white/30 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <a href="#faq" className="text-sm text-white/80 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                  FAQ
                </a>
              </li>
              <li>
                <a href="#blog" className="text-sm text-white/80 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Blog
                </a>
              </li>
              <li>
                <a href="#insurance" className="text-sm text-white/80 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Insurance
                </a>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-white/80 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              <a href="#connect" className="hover:text-[#A8DADC] transition-colors">Connect</a>
            </h4>
            <div className="w-12 h-px bg-white/30 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Contact Us
                </button>
              </li>
              <li>
                <a href="tel:555-0123" className="text-sm text-white/80 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                  (555) 123-4567
                </a>
              </li>
              <li>
                <a href="mailto:info@liveyourbestlifetherapy.com" className="text-sm text-white/80 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                  info@liveyourbestlifetherapy.com
                </a>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Book Appointment
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex items-end justify-between pt-12 border-t border-white/20">
          <div>
            <h3 className="text-5xl font-bold mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
              Live Your Best Life
            </h3>
            <p className="text-base text-white/80" style={{ fontFamily: 'Inter, sans-serif' }}>
              Therapy & Coaching
            </p>
            <div className="w-32 h-px bg-[#A8DADC] mt-3"></div>
          </div>

          <div className="text-right">
            <p className="text-xs text-white/60 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              © 2024 Live Your Best Life Therapy & Coaching. All rights reserved.
            </p>
            <div className="flex items-center gap-4 justify-end">
              <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center hover:text-[#A8DADC] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center hover:text-[#A8DADC] transition-colors cursor-pointer">
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center hover:text-[#A8DADC] transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-xl"></i>
              </a>
            </div>
            <div className="mt-4">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-white/50 hover:text-white/80 transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
